import { api } from "../api";

const ACTIVECAMPAIGN_LIST_NEWSLETTER = Number(process.env.REACT_APP_ACTIVECAMPAIGN_LIST_NEWSLETTER ?? 6);

export const ACService = {
  async saveLead(name, email, phone, list = ACTIVECAMPAIGN_LIST_NEWSLETTER, tag = "", extraPayload = {}) {
    const payload = {
      email,
      list_id: list,
      ...(name  && { name }),
      ...(phone && { phone }),
      ...(tag   && { tag_id: tag }),
      ...extraPayload
    };

    const response = await api.post("crm/subscribe", payload);

    if (response?.data?.status === false) {
      throw new Error(response.data.message ?? "Erro ao inscrever contato.");
    }

    return { status: true };
  },
};